// pages/PainelCliente/MeuPerfil.js

import React, { useEffect, useState } from "react";
import axios from "../../axiosConfig";
import { toast } from "react-toastify";
import "./MeuPerfil.css";

function MeuPerfil() {
  const [perfil, setPerfil] = useState(null);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);

  const [confirmacaoDados, setConfirmacaoDados] = useState(false);
  const [confirmacaoDocumento, setConfirmacaoDocumento] = useState(false);

  useEffect(() => {
    carregarPerfil();
  }, []);

  const carregarPerfil = async () => {
    try {
      const { data } = await axios.get("/cliente/perfil");
      setPerfil(data);
    } catch (err) {
      console.error("Erro ao carregar perfil:", err);
      toast.error("Erro ao carregar perfil.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPerfil((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSalvar = async (e) => {
    e.preventDefault();

    try {
      setSalvando(true);

      await axios.put("/cliente/perfil", {
        nome: perfil.nome,
        cpf_cnpj: documento,
        confirmacao_documento: confirmacaoDocumento,
        confirmacao_dados: confirmacaoDados,
        tipo_pessoa: perfil.tipo_pessoa,
        tipo_identificador_pj: perfil.tipo_identificador_pj,
        identificador_conta_pj: perfil.identificador_conta_pj,
        telefone: perfil.telefone,
        email: perfil.email,
        data_nascimento: perfil.data_nascimento || null,
        genero: perfil.genero || null,
        nome_fantasia: perfil.nome_fantasia || null,
        responsavel_nome: perfil.responsavel_nome || null,
        responsavel_cpf: perfil.responsavel_cpf || null
      });

      const usuarioAtual = JSON.parse(localStorage.getItem("usuario")) || {};
      localStorage.setItem(
          "usuario",
          JSON.stringify({
            ...usuarioAtual,
            nome: perfil.nome,
            email: perfil.email,

            tipo_pessoa: perfil.tipo_pessoa,
            cpf: perfil.cpf,
            cnpj: perfil.cnpj,
            tipo_identificador_pj: perfil.tipo_identificador_pj,
            identificador_conta_pj: perfil.identificador_conta_pj,

            perfil_atualizado: true,
            documento_validado: true,
            termo_pontos_aceito: true,
            forcar_atualizacao_perfil: false
          })
        );

      toast.success("Perfil atualizado com sucesso!");
    } catch (err) {
      console.error("Erro ao salvar perfil:", err);
      toast.error(err.response?.data?.error || "Erro ao salvar perfil.");
    } finally {
      setSalvando(false);
    }
  };

  const documento =
    perfil?.tipo_pessoa === "juridica" ? perfil?.cnpj : perfil?.cpf;

    const precisaConfirmacaoObrigatoria =
      perfil?.forcar_atualizacao_perfil ||
      !perfil?.perfil_atualizado ||
      !perfil?.documento_validado;

  if (loading) {
    return <div className="meuPerfil-page">Carregando perfil...</div>;
  }

  if (!perfil) {
    return <div className="meuPerfil-page">Perfil não encontrado.</div>;
  }

  return (
    <div className="meuPerfil-page">
      <div className="meuPerfil-header">
        <div>
          <h2>Meu Perfil</h2>
          <p>Atualize seus dados cadastrais e mantenha sua conta segura.</p>
        </div>
      </div>

      <form className="meuPerfil-card" onSubmit={handleSalvar}>
        <div className="meuPerfil-section">
          <h3>Dados principais</h3>

          <div className="meuPerfil-grid">
            <div className="meuPerfil-field">
              <label>Tipo de conta</label>
              <select
                name="tipo_pessoa"
                value={perfil.tipo_pessoa || "fisica"}
                onChange={handleChange}
                disabled={!precisaConfirmacaoObrigatoria || perfil.perfil_atualizado}
              >
                <option value="fisica">
                  Pessoa Física / colaborador
                </option>

                <option value="juridica">
                  Pessoa Jurídica / empresa
                </option>
              </select>
            </div>

            <div className="meuPerfil-field">
              <label>{perfil.tipo_pessoa === "juridica" ? "CNPJ" : "CPF"}</label>
                  <input
                    name="cpf_cnpj"
                    value={documento || ""}
                    onChange={(e) => {
                      const valor = e.target.value;

                      setPerfil((prev) => ({
                        ...prev,
                        [prev.tipo_pessoa === "juridica" ? "cnpj" : "cpf"]: valor
                      }));
                    }}
                    disabled={!precisaConfirmacaoObrigatoria || perfil.perfil_atualizado}
                  />

                  {!precisaConfirmacaoObrigatoria && (
                    <small>
                      O documento não pode ser alterado pelo cliente.
                    </small>
                  )}
                  </div>

                  {perfil.tipo_pessoa === "juridica" && (
                    <div className="meuPerfil-pj-box">

                      <div className="meuPerfil-termo">
                        <strong>Atenção:</strong>

                        contas PJ podem representar a empresa,
                        um setor/departamento
                        ou um colaborador autorizado.
                      </div>

                      <div className="meuPerfil-field">
                        <label>Esta conta representa</label>

                        <select
                          name="tipo_identificador_pj"
                          value={perfil.tipo_identificador_pj || ""}
                          onChange={handleChange}
                          required={precisaConfirmacaoObrigatoria}
                        >
                          <option value="">Selecione</option>

                          <option value="empresa">
                            A empresa como um todo
                          </option>

                          <option value="departamento">
                            Um setor/departamento
                          </option>

                          <option value="colaborador">
                            Um colaborador específico
                          </option>
                        </select>
                      </div>

                      <div className="meuPerfil-field">

                        <label>
                          {perfil.tipo_identificador_pj === "departamento"
                            ? "Nome do setor/departamento"
                            : perfil.tipo_identificador_pj === "colaborador"
                            ? "Nome do colaborador"
                            : "Identificador da conta"}
                        </label>

                        <input
                          name="identificador_conta_pj"
                          value={perfil.identificador_conta_pj || ""}
                          onChange={handleChange}
                          required={precisaConfirmacaoObrigatoria}
                        />
                      </div>

                    </div>
                  )}

            <div className="meuPerfil-field">
              <label>Nome / Razão social</label>
              <input
                name="nome"
                value={perfil.nome || ""}
                onChange={handleChange}
                required
              />
            </div>

            <div className="meuPerfil-field">
              <label>E-mail</label>
              <input
                type="email"
                name="email"
                value={perfil.email || ""}
                onChange={handleChange}
                required
              />
            </div>

            <div className="meuPerfil-field">
              <label>Telefone</label>
              <input
                name="telefone"
                value={perfil.telefone || ""}
                onChange={handleChange}
                required
              />
            </div>

            {perfil.tipo_pessoa === "fisica" && (
              <>
                <div className="meuPerfil-field">
                  <label>Data de nascimento</label>
                  <input
                    type="date"
                    name="data_nascimento"
                    value={perfil.data_nascimento ? String(perfil.data_nascimento).slice(0, 10) : ""}
                    onChange={handleChange}
                    required={perfil.tipo_pessoa === "fisica"}
                  />
                </div>

                <div className="meuPerfil-field">
                  <label>Gênero</label>
                  <select
                    name="genero"
                    value={perfil.genero || ""}
                    onChange={handleChange}
                  >
                    <option value="">Prefiro não informar</option>
                    <option value="feminino">Feminino</option>
                    <option value="masculino">Masculino</option>
                    <option value="outro">Outro</option>
                  </select>
                </div>
              </>
            )}

            {perfil.tipo_pessoa === "juridica" && (
              <>
                <div className="meuPerfil-field">
                  <label>Nome fantasia</label>
                  <input
                    name="nome_fantasia"
                    value={perfil.nome_fantasia || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="meuPerfil-field">
                  <label>Responsável</label>
                  <input
                      name="responsavel_nome"
                      value={perfil.responsavel_nome || ""}
                      onChange={handleChange}
                      required={perfil.tipo_pessoa === "juridica"}
                    />
                </div>

                <div className="meuPerfil-field">
                  <label>CPF do responsável</label>
                  <input
                    name="responsavel_cpf"
                    value={perfil.responsavel_cpf || ""}
                    onChange={handleChange}
                    required={perfil.tipo_pessoa === "juridica"}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <div className="meuPerfil-section">
          <h3>Empresa vinculada</h3>

          <div className="meuPerfil-grid">
            <div className="meuPerfil-field">
              <label>CNPJ da empresa</label>
              <input value={perfil.cnpj_empresa || "—"} disabled />
            </div>

            <div className="meuPerfil-field">
              <label>Razão social</label>
              <input value={perfil.nome_empresa || "—"} disabled />
            </div>

            <div className="meuPerfil-field">
              <label>Cidade</label>
              <input value={perfil.cidade || "—"} disabled />
            </div>

            <div className="meuPerfil-field">
              <label>UF</label>
              <input value={perfil.estado || "—"} disabled />
            </div>
          </div>
        </div>

        <div className="meuPerfil-termo">
          <strong>Importante:</strong> os pontos são pessoais e intransferíveis. Para contas PJ, os pontos pertencem à empresa cadastrada no CNPJ informado.
        </div>

        <div className="meuPerfil-confirmacoes">

            <label className="meuPerfil-check">
              <input
                type="checkbox"
                checked={confirmacaoDados}
                onChange={(e) => setConfirmacaoDados(e.target.checked)}
              />

              <span>
                Confirmo que os dados cadastrais acima estão corretos.
              </span>
            </label>

              {precisaConfirmacaoObrigatoria && (
                <div className="meuPerfil-documento-confirmacao">
                  <h4>Confirmação do documento</h4>
                  <p>
                    Confira com atenção o CPF/CNPJ informado. Esse número será usado como
                    identificação principal da conta TikPontos e não poderá ser alterado
                    depois pelo cliente.
                  </p>

                  <label className="meuPerfil-check destaque">
                    <input
                      type="checkbox"
                      checked={confirmacaoDocumento}
                      onChange={(e) => setConfirmacaoDocumento(e.target.checked)}
                    />
                    <span>
                      Confirmo que o CPF/CNPJ informado está correto e pertence ao titular
                      desta conta.
                    </span>
                  </label>
                </div>
              )}
          </div>

        <div className="meuPerfil-actions">
          <button
              type="submit"
              disabled={
                salvando ||
                !confirmacaoDados ||
                (precisaConfirmacaoObrigatoria && !confirmacaoDocumento)
              }
            >
            {salvando ? "Salvando..." : "Salvar alterações"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default MeuPerfil;